import axios from "axios";
import {Vga} from "@/api/types";
import getApiDomain from "@/api/getApiDomain";

const getVgas = async () => {
	const response = await axios.get<Vga[]>(getApiDomain() + "/api/vga", {
		headers: {
			'X-HTTP-AUTHORIZATION': `Authenticate ${localStorage.getItem("auth_token")}`,
			'Access-Control-Allow-Origin': '*',
		}
	}).catch(function (e) {
		const error = e.toJSON();
		if(error.status !== 500){
			throw e;
		}
	});
	if(!response){
		return [];
	}
	return response.data;
};

export default getVgas;
